export default "__VITE_ASSET__7bf1dbe3__"